// extracted by mini-css-extract-plugin
module.exports = {"logoContainer":"SponsorBasicInfo_logoContainer__2ULGZ","logoPreview":"SponsorBasicInfo_logoPreview__1pKEZ"};